import SideMenu from '@v2/shared/Layouts/SideMenu';
import SideMenuFooterLink from '@v2/shared/components/SideMenuFooterLink';
import type { FullLayoutProps } from '@v2/shared/lib/types';
import Full from '../Full';
import { INSTITUTIONAL_MENU } from './menu';

/**
 * The shell MagSpot's institutional pages share — about, faq, contact, the policies.
 *
 * DiscountMags' and TopMags' Institutional layouts' counterpart: the same name, the same
 * props and the same rail, resolved by brand exactly as `Layouts.Full` and
 * `Layouts.Account` already are. A page declares `layoutName = 'Layouts.Institutional'`
 * and gets its own brand's chrome without knowing which brand it is on, and draws its own
 * breadcrumb.
 *
 * Built on Full directly rather than on a SideMenuLayout, which is what the Account layout
 * beside it does. What differs between the two MagSpot layouts is only which list is in
 * the rail.
 *
 * No Container and no padding here: Full draws them.
 */
export type InstitutionalLayoutProps = FullLayoutProps & {
  /** The menu entry to mark, as its path — `/tos`. */
  activePath?: string;
};

export default function Institutional({
  children,
  activePath,
  ...fullProps
}: InstitutionalLayoutProps) {
  return (
    <Full {...fullProps}>
      <SideMenu
        label="Customer information"
        ariaLabel="About MagSpot"
        groups={INSTITUTIONAL_MENU}
        activePath={activePath}
        footer={<SideMenuFooterLink activePath={activePath} />}
      >
        {children}
      </SideMenu>
    </Full>
  );
}
